export default "__VITE_ASSET__vztnfxMy__"